import FormattedMessage from 'I18n/components/FormattedMessage';
import { calculateKYCStatus, hasCompletedUnderwritingReview } from 'growth-payments-core/eligibility/utils';
import EmbedPointContextProvider from 'payments-embed-points-lib/components/EmbedPointContextProvider';
import GoToPaymentsButtonWrapper from 'payments-embed-points-lib/components/GoToPaymentsButtonWrapper';
import { Screen, Subscreen } from 'payments-embed-points-lib/types/screen';
import { useCommerceHomeUrl } from '../../hooks/usePaymentHooks';
import useHasCompletedPaymentsApplication from '../commercePayment/hooks/useHasCompletedPaymentsApplication';
import Skeleton from '../../../chicklets/Skeleton';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PAYMENTS_DISCOVERY_POINT_TEST_ID = 'SubscriptionCardEmptyState-paymentsDiscoveryPoint';
export const EMPTY_STATE_SETUP_BUTTON_TEST_ID = 'SubscriptionCardEmptyState-emptyStateSetupButton';
export let SUBSCRIPTION_SETUP_CTA_MESSAGE;
(function (SUBSCRIPTION_SETUP_CTA_MESSAGE) {
  SUBSCRIPTION_SETUP_CTA_MESSAGE["DEFAULT"] = "cardAssociatedObjects.emptyState.SUBSCRIPTION.default";
})(SUBSCRIPTION_SETUP_CTA_MESSAGE || (SUBSCRIPTION_SETUP_CTA_MESSAGE = {}));
const EmptyStateMessage = () => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: SUBSCRIPTION_SETUP_CTA_MESSAGE.DEFAULT
  });
};
const MessageActionButton = () => {
  const href = useCommerceHomeUrl();
  return /*#__PURE__*/_jsx(EmbedPointContextProvider, {
    screen: Screen.CRM,
    subscreen: Subscreen.CRM_SUBSCRIPTIONS,
    children: ({
      handlePaymentsInterstitialModalOpen
    }) => /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        marginBlockStart: "400",
        children: /*#__PURE__*/_jsx(GoToPaymentsButtonWrapper, {
          page: Screen.CRM,
          location: Subscreen.CRM_SUBSCRIPTIONS,
          use: "tertiary-light",
          size: "small",
          onClick: handlePaymentsInterstitialModalOpen(),
          href: href,
          "data-selenium-test": EMPTY_STATE_SETUP_BUTTON_TEST_ID,
          "data-test-id": EMPTY_STATE_SETUP_BUTTON_TEST_ID
        })
      })
    })
  });
};
const PaymentsDiscoveryPoint = () => {
  const {
    underwritingStatus
  } = useHasCompletedPaymentsApplication();
  const shouldShowMessageActionButton = !hasCompletedUnderwritingReview(calculateKYCStatus(underwritingStatus));
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-test": PAYMENTS_DISCOVERY_POINT_TEST_ID,
    "data-test-id": PAYMENTS_DISCOVERY_POINT_TEST_ID,
    children: [/*#__PURE__*/_jsx(EmptyStateMessage, {}), shouldShowMessageActionButton && /*#__PURE__*/_jsx(MessageActionButton, {})]
  });
};
const SubscriptionCardEmptyState = ({
  cardId,
  numberOfProperties
}) => {
  const {
    loading
  } = useHasCompletedPaymentsApplication();
  if (loading) {
    return /*#__PURE__*/_jsx(Skeleton, {
      cardId: cardId,
      numberOfProperties: numberOfProperties
    });
  }
  return /*#__PURE__*/_jsx(PaymentsDiscoveryPoint, {});
};
export default SubscriptionCardEmptyState;